import React from "react";
import "./Contact.scss";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="contact__glow contact__glow--left" />
      <div className="contact__glow contact__glow--right" />

      <div className="contact__container">
        <header className="contact__heading">
          <span className="contact__eyebrow">CONNECT WITH VIEWGENER</span>
          <h2>CONTACT</h2>

          <p>
            Let&apos;s explore opportunities, partnerships and ideas that create
            value across generations.
          </p>

          <span className="contact__line" />
        </header>

        <div className="contact__content">
          <div className="contact__information">
            <span className="contact__number">01</span>
            <h3>GET IN TOUCH</h3>

            <p className="contact__intro">
              For business enquiries, partnerships and collaboration
              opportunities, contact the ViewGeneR team.
            </p>

            <div className="contact__details">
              <div className="contact__detail">
                <span>LOCATION</span>
                <p>Utrecht, The Netherlands</p>
              </div>

              {/* PHONE oculto hasta disponer de un número empresarial */}

              <div className="contact__detail">
                <span>EMAIL</span>
                <a href="mailto:info@viewgener.com">
                  info@viewgener.com
                </a>
              </div>

              <div className="contact__detail">
                <span>COMPANY DETAILS</span>
                <p>KvK: 90755502</p>
                <p>BTW: NL004838681B94</p>
              </div>
            </div>
          </div>

          <div className="contact__form-wrapper">
            <span className="contact__number">02</span>
            <h3>SEND US A MESSAGE</h3>

            <form
              id="contact-form"
              className="contact__form"
              action="/php/mail.php"
              method="post"
            >
              <div className="contact__form-row">
                <div className="contact__field">
                  <label htmlFor="contact-name">NAME</label>
                  <input
                    id="contact-name"
                    name="user_name"
                    type="text"
                    placeholder="Your name"
                    required
                  />
                </div>

                <div className="contact__field">
                  <label htmlFor="contact-email">EMAIL</label>
                  <input
                    id="contact-email"
                    name="user_email"
                    type="email"
                    placeholder="Your email address"
                    required
                  />
                </div>
              </div>

              <div className="contact__field">
  <label htmlFor="contact-subject">SUBJECT</label>
  <input
    id="contact-subject"
    name="subject"
    type="text"
    placeholder="Subject of your message"
    required
  />
</div>
              <div className="contact__field">
                <label htmlFor="contact-message">MESSAGE</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows="6"
                  placeholder="Tell us more about your needs..."
                  required
                />
              </div>

              <button className="contact__button" type="submit">
                <span>SEND MESSAGE</span>
                <span aria-hidden="true">→</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;